"use client"

// Barra de gravação em curso: cronômetro, descartar e concluir. Genérica —
// pareia com `useDictation` em qualquer campo do app que aceite ditado.
import { Button } from "@immi/ui/components/button"
import { Loader2, Square, X } from "lucide-react"

function formatSeconds(total: number): string {
  const minutes = Math.floor(total / 60)
  const seconds = total % 60
  return `${minutes}:${seconds.toString().padStart(2, "0")}`
}

export function DictationBar({
  seconds,
  isTranscribing,
  onCancel,
  onFinish,
}: {
  seconds: number
  isTranscribing: boolean
  onCancel: () => void
  onFinish: () => void
}) {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-primary-200 bg-primary-50/60 px-3 py-2">
      {isTranscribing ? (
        <>
          <Loader2 className="size-4 shrink-0 animate-spin text-primary-700" />
          <p role="status" className="flex-1 text-sm text-ink-body">
            Transcrevendo…
          </p>
        </>
      ) : (
        <>
          <span
            aria-hidden
            className="size-2.5 shrink-0 animate-pulse rounded-full bg-feedback-error-accent motion-reduce:animate-none"
          />
          <p role="status" className="flex-1 text-sm text-ink-body">
            Gravando{" "}
            <span className="tabular-nums">{formatSeconds(seconds)}</span>
          </p>
          <Button
            size="icon-sm"
            variant="outline"
            aria-label="Descartar gravação"
            onClick={onCancel}
            className="rounded-full"
          >
            <X className="size-4" />
          </Button>
          <Button
            size="icon-sm"
            aria-label="Concluir gravação e transcrever"
            onClick={onFinish}
            className="rounded-full"
          >
            <Square className="size-3.5 fill-current" />
          </Button>
        </>
      )}
    </div>
  )
}
